
<template>
  <!--活动管理 结算详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>结算详情</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="8">
                <a-form-item class="value-indent" :label="item.key == 'img'? '':item.label">
                  <div class="pic-box" v-if="item.key=='img'">
                    <img :src="item.value" alt="">
                  </div>
                  <span v-if="item.key!='img'" class="ant-form-text">{{item.value}}</span>
                </a-form-item>
              </a-col>
          </a-row>
        </div>
      </div>
    </a-form>
    <div class="card">
      <div class="card-head">
        <h3>结算明细</h3>
      </div>
      <div class="card-body">
        <x-tabula
          ref="table"
          rowKey="id"
          :dataSource="tableData"
          :columns="loginColumns"
          :rowSelection="false"
          :listApi="listApi"
        >
        </x-tabula>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activitySettlementDetail',
  data () {
    return {
      baseInfo: [
        {key: 'title', label: '活动名称', value: ''},
        {key: 'stopTime', label: '活动截止时间', value: ''},
        {key: 'settlementTime', label: '结算时间', value: ''},
        {key: 'applyNum', label: '报名数量', value: ''},
        {key: 'totalFee', label: '订单总金额', value: ''},
        {key: 'orderFee', label: '订单总金额（不含运费）', value: ''},
        {key: 'platformServiceFee', label: '平台服务费', value: ''},
        {key: 'totalSettleFee', label: '结算金额', value: ''}
      ],
      loginColumns: [
        { title: '昵称', dataIndex: 'nickName', align: 'left', width: '' },
        { title: '账号', dataIndex: 'mobilePhone', align: 'left', width: '' },
        { title: '项目', dataIndex: 'item', align: 'left', width: '' },
        { title: '报名时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '订单金额（不含运费）', dataIndex: 'singleOrderFee', align: 'left', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.singleOrderFee} })},
        { title: '运费', dataIndex: 'singleFreight', align: 'left', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.singleFreight} }) },
        { title: '订单总额', dataIndex: 'singleTotalFee', align: 'left', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.singleTotalFee} }) },
        { title: '实付金额', dataIndex: 'singlePayFee', align: 'left', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.singlePayFee} }) },
        { title: '平台服务费', dataIndex: 'singlePlatformServiceFee', align: 'left', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.singlePlatformServiceFee} }) },
        { title: '结算金额', dataIndex: 'singleSettingFee', align: 'left', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.singleSettingFee} }) }
      ],
      tableData: [],
      listApi: {
        url: ''
      }

    };
  },
  filters: {
    toMoney (val) {
      if (val != null) {
        return '￥' + Number(val).toFixed(2);
      } else {
        return '';
      }
    }
  },
  created () {
    this.listApi.url = '/activity/settlementList/' + this.$route.query.id;
    this.getDetail();
  },
  beforeRouteEnter (to, from, next) {
    next();
    setTimeout(() => {
      document.getElementsByClassName('layout-content')[0].style.padding = '0px';
      document.getElementsByClassName('layout-content')[0].style.backgroundColor = 'transparent';
    }, 0);
  },
  beforeRouteLeave (to, from, next) {
    document.getElementsByClassName('layout-content')[0].style.padding = '16px';
    document.getElementsByClassName('layout-content')[0].style.backgroundColor = '#fff';
    next();
  },
  methods: {
    getDetail () {
      this.$get({
        url: `/activity/settlement/${this.$route.query.id}`,
        params: {}
      }).then(({data}) => {
        for (let item in data) {
          this.baseInfo.forEach((el) => {
            if (el.key === item) {
              if (el.label == '平台服务费') {
                el.value = '￥' + data[item];
              } else {
                el.value = el.label.indexOf('金') > -1 ? '￥' + data[item] : data[item];
              }
            }
          });
        }
      });
    }
  }
};
</script>
<style scoped >
.pic-box{
  width:200px;
  height: 70px;
  max-height: 70px;
  overflow: hidden;
}
.pic-box img{
  height: 70px;
  width: auto !important;
  max-height: 70px;
}
  .card{
    margin-bottom:24px;
  }
</style>
